const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.17,4.25c.98,0,1.83.83,1.84,1.78v5.92h-3.6c-2.3,0-4.16-1.94-4.16-4.32h.62c0,2.03,1.59,3.68,3.54,3.68h2.99v-5.28c0-.6-.58-1.14-1.21-1.14h-7.55v2.73h-.62v-3.37h8.16Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.08,7.62c0,.75.6,1.37,1.32,1.37v.64c-1.07,0-1.94-.91-1.94-2.01h.62Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.63,7.62c0,3.31,2.58,6,5.77,6v.63c-3.52,0-6.39-2.98-6.39-6.63h.62Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#5a50f9"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.01,4.25h10v7.69H4.01v-7.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46,7.62h1.94v2.01h-1.94v-2.01Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.01,7.62h6.39v6.63h-6.39v-6.63Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalPay);
export default __webpack_public_path__ + "static/media/personal-pay.3588c3d7c20d2676407ffb77720c03b6.svg";
export { ForwardRef as ReactComponent };